export enum ChangeIndicator {
  arrowUp = 'arrow-up',
  arrowDown = 'arrow-down',
}

export type EditActivityEntityApi = {
  prev_value: string | null;
  curr_value: string;
  column_id: string;

  icons: {
    kind: ChangeIndicator;
  }[];
};

export type EditActivityEntity = {
  prevValue: string | null;
  currValue: string | null;
  columnId: string;

  formFieldId: string;
  icons: {
    kind: ChangeIndicator;
  }[];

  label: string;
};
